import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Say Hi,`}<a parentName="p" {...{
        "href": "mailto:costa.anton@hotmail.com"
      }}>{` on my email address`}</a>{`, or find me on other platforms: `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/costa-anton-9b144410a/"
      }}>{`Linkedin`}</a>{`.`}<br parentName="p"></br>{`
`}{`You can also download my `}<a parentName="p" {...{
        "href": "./CV.pdf"
      }}>{`CV`}</a>{` if you wish to take a look at it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      